import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProviderCard } from "../../../data/ecommerce/providers";
import ProductCard from "../../common/ProductCard";
import Swiper from "../../base/Swiper";
import { SwiperSlide } from "swiper/react";
import { faBolt, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useTagsStore } from "../../../store/tagsStore";
// procucts are actually stores in this case
const EcomTopProviders = ({ providers }: { providers: ProviderCard[] }) => {
  const { providerTopUser } = useTagsStore.getState();

  return (
    <>
      <div className="d-flex flex-between-center mb-3">
        <div className="d-flex">
          <FontAwesomeIcon icon={faBolt} className="text-warning fs-6" />
          <h3 className="mx-2">Proveedores Top</h3>
          <FontAwesomeIcon icon={faBolt} className="text-warning fs-6" />
        </div>
        <Link
          to={`/home/searchpage?rating=${providerTopUser?.id}`}
          className="btn btn-link btn-lg p-0 d-none d-md-block"
        >
          Ver mas
          <FontAwesomeIcon icon={faChevronRight} className="fs-9 ms-1" />
        </Link>
      </div>
      <Swiper
        slidesPerView={1}
        spaceBetween={16}
        navigationPosition={{ top: "25%" }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          450: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1540: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
        }}
      >
        {/* for some reson when i change the name of prop to provider, it breaks the code. I will have to look into this later */}
        {providers.map((provider) => (
          <SwiperSlide key={provider.id}>
            <ProductCard product={provider} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default EcomTopProviders;
